import React, { Component} from 'react';
import { connect }   from 'react-redux'
import { setFilter } from '../../actions/FilterAction';
import Filters       from '../Filters';

class FilterContainer extends Component
{
    render = () =>
    {
        return (<Filters { ...this.props } />);
    }
}

const mapStateToProps = (state) => {
    return {
        tags    : state.tags,
        filters : state.filter.filters,
        selected: state.filter.selected,
        theme   : state.assets.items.theme.filters
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        selectFilter: (filter) => {
            dispatch(setFilter(filter));
        }
    }
};

FilterContainer = connect(mapStateToProps, mapDispatchToProps)(FilterContainer);

export default FilterContainer;


// WEBPACK FOOTER //
// ./src/components/containers/FilterContainer.js